import React, { JSX } from 'react';
import { ITableDataSource } from 'models/table';
import Grid from '@mui/material/Grid';
import { colors } from 'theme/colors';
import { Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';

interface ISearchResultTableCard {
  data: ITableDataSource;
  handleView: (args: string) => void;
  renderHighlight: (arg: string) => '-' | JSX.Element;
}

const SearchResultFirearmTableCard = ({
  data,
  handleView,
  renderHighlight,
}: ISearchResultTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: colors.gray200,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('Firecycle ID')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.fireCycleId)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.serialNumber.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.serialNumber)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.make.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.make)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.model.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.model)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.manufacturer.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.manufacturer)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.calibre.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.calibre)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.keeper.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.keeperName)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('registeredFirearms.accordion.owner.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.ownerName)}</Typography>
      </Grid>

      {handleView && (
        <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: {
              xs: `1px solid ${colors.primary100}`,
              lg: 'none',
            }, p: 2 }}>
          <>
            <Grid size={{ xs: 12, sm: 3 }} sx={{ mb: { xs: 2, sm: 0 } }}>
              <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
                {t('general.actions.text')}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Button
                label={t('general.details.text')}
                variant={EButtonVariants.outlined}
                onClick={() => handleView(data.id as string)}
                size="small"
                fullWidth
              />
            </Grid>
          </>
        </Grid>
      )}
    </Grid>
  );
};

export default SearchResultFirearmTableCard;
